import { TRESPONSE_OPLDetailsDTO } from '@monorepo/types';
import moment from 'moment';
import { ModifiersZTableModel } from '../../table.modifier';

export const SPLIT_SCREEN_TABLE_MODEL = {
  createModel: (data: TRESPONSE_OPLDetailsDTO['plannedInfoByDates']) => {
    const rows: { label: string; key: keyof TRESPONSE_OPLDetailsDTO['plannedInfoByDates'][number] }[] = [
      { label: 'Planned Qty', key: 'qtyOnDate' },
      { label: 'Planned Qty From', key: 'qtyFromDate' },
    ];

    return ModifiersZTableModel.createTableModel(
      rows,
      {
        headerConfig: getHeaderConfig(data),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: getRow(data, item),
        };
      },
    );
  },
};

function getHeaderConfig(headerInfo: TRESPONSE_OPLDetailsDTO['plannedInfoByDates']) {
  return [
    {
      type: 'TEXT_CELL' as const,
      text: 'Date',
      stickyType: 'LEFT' as const,
      stickyPosition: 1,
    },
    ...headerInfo.map((hInfo) => ({
      type: 'TEXT_LIST_CELL' as const,
      text: [moment(hInfo.date).format('MMM YYYY'), moment(hInfo.date).format('D')],
    })),
  ];
}

const getRow = (
  itemData: TRESPONSE_OPLDetailsDTO['plannedInfoByDates'],
  row: { label: string; key: keyof TRESPONSE_OPLDetailsDTO['plannedInfoByDates'][number] },
) => {
  return [
    {
      type: 'TEXT_CELL' as const,
      text: row.label,
      align: 'left' as const,
    },
    ...itemData.map((itemInfo) => ({
      type: 'TEXT_CELL' as const,
      text: itemInfo[row.key],
    })),
  ];
};
